import { render, staticRenderFns } from "./IconSettings.vue?vue&type=template&id=dd904bc6&"
import script from "./IconSettings.vue?vue&type=script&lang=ts&"
export * from "./IconSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports